import { connect } from 'react-redux';
import { comparisonOptionNames } from '../../models';
import LocationContainer from './location-container';

const mapStateToProps = state => ({
  selectedReport: state.reports.selectedReport,
  selectedLocation: state.reports.selectedLocation,
  comparisonDateRanges: state.filter.comparisonDateRanges.filter(cdr => cdr.option !== comparisonOptionNames.none),
  useMultiLocationComparison: state.filter.useMultiLocationComparison,
  locations: state.reports.locations,
  isLoadingLocations: state.reports.isLoadingLocations,
});

const mapDispatchToProps = () => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(LocationContainer);
